<template>
<div class="ThirdPartyCompanyProjectMonthFlow">
  <el-tabs v-model="tabsIndex">
    <el-tab-pane label="审核信息" name="ThirdPartyCompanyProjectMonthDetails">
      <ThirdPartyCompanyProjectMonthDetails
        v-if="formData.cps_id && tabsIndex==='ThirdPartyCompanyProjectMonthDetails'"
        :from-data="formData"
        :year-month="formData.yearmonth"
      />
    </el-tab-pane>
    <el-tab-pane label="移交信息" name="ThirdPartyCompanyProjectMonthDetails2">
      <el-descriptions :column="3" border :label-style="{width: '90px'}" :content-style="{width: 'calc(30vw - 300px)'}">
        <el-descriptions-item label="移交历史">
          <el-button size="mini" @click="dialogVisible2=true">查看</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="审批流程">
          <el-button size="mini" v-if="formData.task_id" @click="$refs.viewFlowRef.show({task_id:formData.task_id})">查看</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="移交文件">
          <el-button size="mini" v-if="formData.file_id" @click="$refs.viewFileListRef.show(formData.file_id)">查看</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-tab-pane>
  </el-tabs>

  <el-dialog title="" :visible.sync="dialogVisible2" :close-on-click-modal="false" @close="dialogVisible2=false" width="95vw">
    <ThirdPartyLitigationLegalHistory2 v-if="dialogVisible2" :id="formData.id" />
    <template #footer>
      <div style="">
        <el-button size="mini" @click="dialogVisible2=false">关 闭</el-button>
        <!--          <el-button size="mini" @click="save">确认</el-button>-->
      </div>
    </template>
  </el-dialog>
  <ViewFileList ref="viewFileListRef" />
  <ViewFlow ref="viewFlowRef" />
</div>
</template>

<script>
import ThirdPartyCompanyProjectMonthDetails from "./ThirdPartyCompanyProjectMonthDetails";
import ButlerHttp from "../../common/ButlerHttp";
import ViewFileList from "../../../Common/ViewFileList";
import ViewFlow from "../../../Common/ViewFlow";
import ThirdPartyLitigationLegalHistory2 from "../thirdparty_litigation/ThirdPartyLitigationLegalHistory2";
export default {
  name: "ThirdPartyCompanyProjectMonthFlow",
  components: {
    ThirdPartyLitigationLegalHistory2,
    ViewFlow, ViewFileList, ThirdPartyCompanyProjectMonthDetails},
  data(){
    return{
      id:0,
      formData:{},
      tabsIndex:"ThirdPartyCompanyProjectMonthDetails",
      dialogVisible2:false,
    }
  },
  mounted() {
    this.id = this.$route.query.batch_number;
    this.getData();
  },
  methods:{
    getData(){
      const that = this;
      if(!that.id){
        return;
      }
      ButlerHttp.post("ThirdPartyCommon/getProjectCompanyMonth", {
        id: that.id,
      }, res => {
        if (res.code) {
          that.formData = res.data;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.ThirdPartyCompanyProjectMonthFlow{
  width: 100%;
  padding: 20px;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectMonthFlow.vue